import ListCropFields from "@/views/organization/partners/crop_fields/ListCropFields.vue";
// import ListCropFieldsFormalizedActive from "@/components/views/organization/partners/crop_fields/ListCropFieldsFormalizedActive.vue";
// import ListCropFieldsNotFormalizedActive from "@/components/views/organization/partners/crop_fields/ListCropFieldsNotFormalizedActive.vue";
// import ListCropFieldsInactive from "@/components/views/organization/partners/crop_fields/ListCropFieldsInactive.vue";
// import ShowCropField from "@/views/organization/partners/crop_fields/ShowCropField.vue";
// import NewCropField from "@/views/organization/partners/crop_fields/NewCropField.vue";
// import EditCropField from "@/views/organization/partners/crop_fields/EditCropField.vue";
// import NewCropField from "@/views/organization/partners/crop_fields/NewCropField.vue";
// import EditCropField from "@/views/organization/partners/crop_fields/EditCropField.vue";


import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "partners",
  permission: "crop_fields"
});

export default [
  {
    path: "/org/:organization_id/partners/crop_fields/list",
    name: routeName(""),
    redirect: { name: routeName("list_crop_fields") }
  },
  {
    path: "/org/:organization_id/partners/crop_fields/list",
    name: routeName("list_crop_fields"),
    // redirect: { name: routeName("list_crop_fields_formalized_active") },
    component: ListCropFields,
    props: true,
    meta: META,
    // children: [
    //   {
    //     path: "formalized_active",
    //     name: routeName("list_crop_fields_formalized_active"),
    //     alias: "",
    //     component: ListCropFieldsFormalizedActive,
    //     props: true
    //   },
    //   {
    //     path: "not_formalized_active",
    //     name: routeName("list_crop_fields_not_formalized_active"),
    //     component: ListCropFieldsNotFormalizedActive,
    //     props: true
    //   },
    //   {
    //     path: "inactive",
    //     name: routeName("list_crop_fields_inactive"),
    //     component: ListCropFieldsInactive,
    //     props: true
    //   }
    // ]
  },
  // {
  //   path: "/org/:organization_id/partners/crop_fields/:crop_field_id/show",
  //   name: routeName("show_crop_field"),
  //   component: ShowCropField,
  //   props: true,
  //   meta: META
  // },
  // {
  //   path: "/org/:organization_id/partners/crop_fields/new",
  //   name: routeName("new_crop_field"),
  //   component: NewCropField,
  //   props: true,
  //   meta: META
  // },
  // {
  //   path: "/org/:organization_id/partners/crop_fields/:crop_field_id/edit",
  //   name: routeName("edit_crop_field"),
  //   component: EditCropField,
  //   props: true,
  //   meta: META
  // },
  // {
  //   path: "/org/:organization_id/partners/crop_fields/:crop_field_id/new_crop_field",
  //   name: routeName("new_crop_field"),
  //   component: NewCropField,
  //   props: true,
  //   meta: META
  // },
  // {
  //   path: "/org/:organization_id/partners/crop_fields/:crop_field_id/edit_crop_field/:crop_field_id",
  //   name: routeName("edit_crop_field"),
  //   component: EditCropField,
  //   props: true,
  //   meta: META
  // }
];
